import React from 'react';
import Step0Form from './Step/Step0Form';
import Step1Form from './Step/Step1Form';
import Step2Form from './Step/Step2Form';
import Step3Form from './Step/Step3Form';
import Step4Form from './Step/Step4Form';

interface FormStepProps {
  step: number;
  formData: { [key: string]: any };
}
 

const FormStep = ({ step, formData, handleChange, resetForm, sisaDaging, setSisaDaging
 }: { step: number, formData: any, handleChange: any, resetForm: any,   sisaDaging: number,
  setSisaDaging: React.Dispatch<React.SetStateAction<number>>
 }) => {
  switch (step) {
    case 0:
      return <Step0Form formData={formData} handleChange={handleChange} />;
    case 1:
      return <Step1Form formData={formData} handleChange={handleChange} />;
    case 2:
      return <Step2Form formData={formData} handleChange={handleChange} resetForm={resetForm} sisaDaging={sisaDaging} setSisaDaging={setSisaDaging} />;
    case 3:
      return <Step3Form formData={formData} handleChange={handleChange} />;
    case 4:
      return <Step4Form formData={formData} />;
  
    default:
      return null;
  }
};

export default FormStep;